<template>
  <div style="min-width: 80%">
    <h1 class="grey--text text--darken-2">Пользователи</h1>

  </div>
</template>

<script>
  export default {
    data: () => ({
      loading: false,
      items: [],
      page: 1,
      routerPage: 1
    }),
  }
</script>
